module.exports = __webpack_public_path__ + "static/assets/7f270fca24d978ffbd7ea30e37d796e5.svg";